/* ---------------------------------------------------------------------
 *                           Helper Function
 * --------------------------------------------------------------------- */

/**
 * 连接URL的左右部分，删除或添加“/”，以确保中间有一个“/”
 * @param {string} left - url的左侧部分
 * @param {string} right - url的右侧部分
 * @returns 合并的URL
 */
export function joinURL(left, right) {
    while (left[left.length - 1] === "/") {
        left = left.slice(0, left.length - 1);
    }
    while (right[0] === "/") {
        right = right.slice(1);
    }
    return left + "/" + right;
}

/**
 * 处理流数据格式
 * @param {string} responseData - 流数据
 * @returns {string}
 */
export function processStreamData(responseData) {
    const lines = responseData.split('\n').filter(line => line.trim());
    
    const processedContent = lines
        .map(line => {
            const content = line.startsWith('data:') ? line.slice(5) : line;
            return content.trim();
        })
        .join('');
    
    return processedContent;
}